// extracted by mini-css-extract-plugin
export default {"Column":"style_Column__hqYwY","center":"style_center__gSVQ1"};